export default class HomeStats {

    public totalSamples: number | undefined;
    public totalVehicleModels: number | undefined;
    public totalProcessChanges: number | undefined;
    public totalApprovedSamples: number | undefined;

    constructor(data: { [key: string]: any }) {
        this.totalSamples = data['totalSamples'];
        this.totalVehicleModels = data['totalVehicleModels'];
        this.totalProcessChanges = data['totalProcessChanges'];
        this.totalApprovedSamples = data['totalApprovedSamples'];
    }
}